import { isRecord } from '~/utils/isRecord';

export function itemIdentity(value: unknown): string {
  if (isRecord(value)) {
    const identity =
      value.id_cloudinary_external ||
      value.publicImageId ||
      value.imageId ||
      value.idCloudinaryExternal ||
      value.name ||
      value.facilityCode ||
      value.content ||
      value.id;
    if (typeof identity === 'string' || typeof identity === 'number') {
      return String(identity);
    }
  }

  return JSON.stringify(value);
}

export function isUnsetValue(value: unknown): boolean {
  return value === null || value === undefined || value === '';
}
